/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_tooltip_quali_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualifying position delta - green means first driver qualified ahead`)
};

const es_f1_profile_tooltip_quali_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferencia en clasificación - verde significa que el primer piloto clasificó mejor`)
};

const de_f1_profile_tooltip_quali_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualifying-Positions-Delta — Grün bedeutet erster Fahrer hat sich weiter vorne qualifiziert`)
};

const nl_f1_profile_tooltip_quali_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwalificatiepositieverschil — groen betekent dat de eerste coureur hoger kwalificeerde`)
};

const fr_f1_profile_tooltip_quali_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delta de position en qualification — vert signifie que le premier pilote s’est qualifié devant`)
};

const it_f1_profile_tooltip_quali_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delta posizione qualifiche — verde significa che il primo pilota si è qualificato davanti`)
};

const pt_br2_f1_profile_tooltip_quali_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delta de posição na classificatória — verde significa que o primeiro piloto classificou na frente`)
};

const pt_f1_profile_tooltip_quali_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delta de posição na qualificação — verde significa que o primeiro piloto qualificou-se à frente`)
};

const ja_f1_profile_tooltip_quali_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予選ポジション差 — グリーンは先ドライバーが上位予選`)
};

const zh_f1_profile_tooltip_quali_h2h = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排位赛名次差 — 绿色表示第一位车手排名更高`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_tooltip_quali_h2h = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_tooltip_quali_h2h(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_tooltip_quali_h2h", locale)
	if (locale === "en") return en_f1_profile_tooltip_quali_h2h(inputs)
	if (locale === "es") return es_f1_profile_tooltip_quali_h2h(inputs)
	if (locale === "de") return de_f1_profile_tooltip_quali_h2h(inputs)
	if (locale === "nl") return nl_f1_profile_tooltip_quali_h2h(inputs)
	if (locale === "fr") return fr_f1_profile_tooltip_quali_h2h(inputs)
	if (locale === "it") return it_f1_profile_tooltip_quali_h2h(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_tooltip_quali_h2h(inputs)
	if (locale === "pt") return pt_f1_profile_tooltip_quali_h2h(inputs)
	if (locale === "ja") return ja_f1_profile_tooltip_quali_h2h(inputs)
	return zh_f1_profile_tooltip_quali_h2h(inputs)
};